module.exports = __webpack_public_path__ + "img/thank-you-photo.b405848e.jpg";